export default __webpack_public_path__ + "static/media/plus.25349bc0.svg";